import WebView from "./WebView";
import { useMediaQuery } from "@mui/material";
import ReferMobileView from "./ReferMobileView";
export default function Referral() {
  const isSmallScreen = useMediaQuery("(max-width:960px)");
  return <>{isSmallScreen ? <ReferMobileView /> : <WebView />}</>;
}
